import Stack from '@mui/material/Stack';
import BasicDetails from './BasicDetails';
import ChangePassword from './ChangePassword';
import MultiFactor from './MultiFactor';

const General = () => (
  <Stack gap={4}>
    <BasicDetails />
    <ChangePassword />
    <MultiFactor />
  </Stack>
);

export default General;
